import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./globals.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AuthProvider } from "./context/AuthContext";
serviceWorkerRegistration.register();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
     <AuthProvider>
        <App />
     </AuthProvider>
      
    </BrowserRouter>
   //</React.StrictMode>
);